import { Lumber } from '@paragon/contract-library';

export const defaultLumber: Lumber = {
  nominalThickness: '2',
  nominalWidth: '4',
  actualThickness: 1.5,
  actualWidth: 3.5,
  grade: 'Number_1',
  tangibleGrades: [],
  species: 'Southern_Pine',
  tangibleSpecies: [],
  treatmentType: 'Untreated',
  gradingMethod: 'VisuallyGraded',
  structure: 'Sawn',
};
